export function setNewsTexts(state, payload) {
  state.newsTexts = payload;
}

export function clearNewsTexts(state) {
  state.newsTexts = [];
}
